import { render, staticRenderFns } from "./SendMail.vue?vue&type=template&id=f59e72f0"
import script from "./SendMail.vue?vue&type=script&lang=js"
export * from "./SendMail.vue?vue&type=script&lang=js"
import style0 from "./SendMail.vue?vue&type=style&index=0&id=f59e72f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports